import { connect } from 'react-redux';
import queryString from 'query-string';
import { getAlertTitle } from 'module-tsl-jobs-app-utils/app/transforms/job-alert';
import { get as getI18n } from '../../../modules/I18n';
import { getEmail, getMapsApiKey, getSearchDetails, getSavedSearches, getIsMobile } from '../../../modules/Settings';
import SaveSearchBtn from './SaveSearchBtn';

const mapStateToProps = state => {
  const searchDetails = getSearchDetails(state);
  const searchDetailsNoSort = { ...searchDetails };
  delete searchDetailsNoSort.sort;
  const savedSearches = getSavedSearches(state);
  const indexAlreadySaved = savedSearches.map(ss => ss.qs.toLowerCase()).indexOf(queryString.stringify(searchDetails).toLowerCase());
  const currSavedSearch = indexAlreadySaved > -1 ? savedSearches[indexAlreadySaved] : null;

  return {
    searchDetails: Object.keys(searchDetailsNoSort).length > 0 ?
      { ...searchDetailsNoSort,
        sort: searchDetails.sort
      } : null,
    frequency: currSavedSearch ? currSavedSearch.frequency : null,
    alreadySaved: !!currSavedSearch,
    title: getAlertTitle(queryString.stringify(searchDetails)),
    email: getEmail(state),
    id: currSavedSearch ? currSavedSearch.id : null,
    mapsApiKey: getMapsApiKey(state),
    i18n: getI18n(state),
    isMobile: getIsMobile(state),
  };
};
const SaveSearchBtnContainer = connect(mapStateToProps)(SaveSearchBtn);

export default SaveSearchBtnContainer;
